import type { Project } from "../../api/types.js";

export const demoAssets = {
  mark: "/assets/truth_logo_mark.png",
  logo: "/assets/truth_logo.png",
  avatar: "/assets/user-avatar.png"
};

export const DEFAULT_SESSION_TITLE = "新的科研会话";

/**
 * 已用量来自 GET /api/resources/usage 的真实数据；配额目前没有后端来源，先固定 10 GB。
 * 后端提供真实配额后替换这个常量即可，用户卡和设置存储页共用同一份。
 */
export const STORAGE_QUOTA_BYTES = 10 * 1024 * 1024 * 1024;

export function formatFileBytes(value: number) {
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  if (value < 1024 * 1024 * 1024) return `${(value / 1024 / 1024).toFixed(1)} MB`;
  return `${(value / 1024 / 1024 / 1024).toFixed(1)} GB`;
}

export function formatStorageBytes(value: number) {
  return formatFileBytes(value);
}

export const starterPrompts = [
  {
    title: "比较前沿研究路线",
    tag: "文献检索",
    prompt: "检索近 5 年 AI Agent 用于科学实验自动化的研究，选择 5 篇代表性论文，比较技术路线、实验结果与局限，并给出可核验引用。"
  },
  {
    title: "设计综述论文大纲",
    tag: "论文写作",
    prompt: "以化学与材料实验为范围，围绕 2020 年以来 AI 如何改变实验设计、执行和分析，直接设计一份 6 节综述论文大纲，并说明各章节需要什么证据。"
  },
  {
    title: "规划实验数据分析",
    tag: "实验分析",
    prompt: "我正在比较 3 种处理条件对材料性能指标的影响，每组有 10 个独立样本，并存在两个实验批次。请制定统计方法、可视化、异常值处理和结果报告方案。"
  },
  {
    title: "搭建项目资料框架",
    tag: "项目资料",
    prompt: "帮我为一个科研项目设计资料整理结构，覆盖研究问题、文献、原始数据、实验日志、分析结果和待办，并提供一份每周研究进展摘要模板。"
  }
];

export function projectDisplayName(project: Project) {
  return project.name;
}
